"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @private
 */
exports.USER_COMPANY_CS_OPERATOR_ENDPOINT = {
    getOperatorDetails: '/user-company/{{version}}/cs-operators/{{csOperatorUuid}}',
    getLegalDocuments: '/user-company/{{version}}/cs-operators/{{csOperatorUuid}}/legal-documents?language={{language}}',
    getDocumentValidationProviders: '/user-company/{{version}}/cs-operators/document-validation-providers',
    getTermsAndConditions: '/user-company/{{version}}/terms_conditions?cs_operator_uuid={{csOperatorUuid}}&language={{language}}',
};
